import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { FormattedMessage } from 'react-intl';

import { MobileDrawerShell } from '../../../../components/LoanSummary/MobileDrawerShell';
import { ContinueButton } from '../components/ContinueButton';
import { MinMonthlyRepaymentRow } from '../components/MinMonthlyRepaymentRow';
import { SummaryLayout } from '../components/SummaryLayout';
import { useLoanSummaryData } from '../useLoanSummaryData';

export const MobileLoanSummary = ({
    selectedOffer,
    drawdownAmount
}: {
    selectedOffer: TFormalOffer | undefined;
    drawdownAmount: number;
}) => {
    const { monthlyRepayment, fullTermRepayment } = useLoanSummaryData({
        selectedOffer,
        drawdownAmount
    });

    return (
        <MobileDrawerShell data-testid="mobile-loan-summary">
            {({ isOpen, toggle }) =>
                isOpen ? (
                    <SummaryLayout
                        selectedOffer={selectedOffer}
                        drawdownAmount={drawdownAmount}
                        monthlyRepayment={monthlyRepayment}
                        fullTermRepayment={fullTermRepayment}
                    />
                ) : (
                    <div className="space-y-l">
                        <MinMonthlyRepaymentRow amount={monthlyRepayment} />

                        <ContinueButton onClick={toggle}>
                            <FormattedMessage
                                id="_.loan_summary.open_summary_button"
                                defaultMessage="Continue to summary"
                            />
                        </ContinueButton>
                    </div>
                )
            }
        </MobileDrawerShell>
    );
};
